@if (options) {
<div
  #chartContainer
  echarts
  [options]="options"
  (chartClick)="onChartClick($event)"
  (contextmenu)="onChartContextMenu($event)"
  (chartInit)="onChartInit($event)"
  class="h-full w-full"
></div>
}
